import { Component, Input } from '@angular/core';

export interface TimelineItem {
  status: 'success' | 'warning' | 'default';
  time: string;
  title: string;
  description?: string;
  actor?: string;
}

@Component({
  selector: 'app-e-timeline',
  templateUrl: './e-timeline.component.html',
  styleUrls: ['./e-timeline.component.css']
})
export class ETimelineComponent {
  @Input() items: TimelineItem[] = [];
}



// WEBPACK FOOTER //
// /app/src/app/components/e-timeline/e-timeline.component.ts